var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: _vm.visible },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        closed: _vm.dialogClosed
      }
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.school } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "数据类型", prop: "datatype" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.school.datatype,
                    callback: function($$v) {
                      _vm.$set(_vm.school, "datatype", $$v)
                    },
                    expression: "school.datatype"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [_vm._v("学生")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "2" } }, [_vm._v("教师")])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.school.datatype === "1",
                  expression: "school.datatype === '1'"
                }
              ],
              attrs: { label: "", prop: "grade" }
            },
            [
              _c("el-cascader", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.school.datatype === "1",
                    expression: "school.datatype === '1'"
                  }
                ],
                staticStyle: { "margin-left": "68px" },
                attrs: {
                  placeholder: "年级选择",
                  options: _vm.classOption,
                  props: _vm.props,
                  "collapse-tags": "",
                  clearable: ""
                },
                model: {
                  value: _vm.school.grade,
                  callback: function($$v) {
                    _vm.$set(_vm.school, "grade", $$v)
                  },
                  expression: "school.grade"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.determine }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-fecd4808", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-fecd4808","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/operate/SchoolManageDialog.vue
// module id = null
// module chunks = 